import { TotalCropReportTable, TableContentWithoutEditDateFromat } from '../../../Common/Table/tableContent';
import React from "react";
import tokenService from '../../../../Common/tokenDecoder';

export default class ComponentToPrint extends React.Component {
    render() {

        const data = this.props.data;
        const rowNames = this.props.rowNames;
        const searchData = this.props.searchData;
        const totalRow = this.props.totalRow;
        const columeNames = this.props.columeNames;
        const inishialColumName = [{
        title: 'Date', field: 'weightReadTime', render: rowData => rowData.weightReadTime, headerStyle: {
            color: '#000000',
            textAlign: 'center',
            fontWeight: 'bold'
        }, cellStyle: { textAlign: 'left' }

    }]

        return (
            <div>
                <h3><center><u>Total Crop Report</u></center></h3>
                <div className="row pl-2 pb-4 pt-4">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Factory: </b> {searchData.estate}</div>
                    <div className="col"><b>Collection Point: </b> {searchData.collectionID}</div>
                    <div className="col"><b>Month: </b> {searchData.month}</div>
                    <div className="col"><b>User: </b> {tokenService.getUserNameFromToken()}</div>
                    <div className="col"><b>Date/Time: </b> {new Date().toLocaleString()}</div>
                </div>
                <div className="row">
                    <div className="row alternative_cls">

                        <div className="col pb-2 width4">
                            <table id="totalCropPdf">
                                    <thead>
                                        <tr>
                                            {rowNames.map((x, index) => {
                                                let result = x.replace(/([A-Z])/g, " $1");
                                                let finalResult = result.charAt(0).toUpperCase() + result.slice(1);
                                                if (finalResult === "Weight Read Time") {
                                                    finalResult = "Date";
                                                }
                                                return (
                                                    <th key={index}>{finalResult}</th>
                                                );
                                            })}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <TotalCropReportTable
                                            data={data}
                                            contentRowNames={rowNames}
                                            hasEdit={false}
                                        />
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td style={{ fontWeight: "bold", textAlign: "left" }}>TOTAL</td>
                                            <td></td>
                                            {columeNames.map(x => {
                                                var result = totalRow.find(y => y.name === x.field);

                                                if (result) {
                                                    return (
                                                        <td style={{ textAlign: "end", fontWeight: "bold" }}>{result.value}</td>
                                                    );
                                                }

                                            })}
                                        </tr>
                                    </tfoot>
                                </table>
                        </div>
                        <hr />
                    </div>
                </div>
            </div>
        );
    }
}